import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils';
import './styles.css';

interface ChatPreview {
  id: string;
  name: string;
  avatar: string;
  lastMessage: string;
  time: string;
  unreadCount?: number;
  online?: boolean;
}

interface AIPersona {
  id: string;
  name: string;
  avatar: string;
  online?: boolean;
}

const Home: React.FC = () => {
  const navigate = useNavigate();

  // 模拟AI人格数据
  const personas: AIPersona[] = [
    { id: 'user', name: 'My status', avatar: getImageUrl('./img/Rectangle 1092.png', 'user'), online: true },
    { id: 'adil', name: 'Adil', avatar: getImageUrl('./img/Rectangle 1092 (1).png', 'avatar'), online: true },
    { id: 'eva', name: 'Eva', avatar: getImageUrl('./img/eva.png', 'avatar'), online: true },
    { id: 'dean', name: 'Dean', avatar: getImageUrl('./img/Rectangle 1093.png', 'avatar'), online: true },
    { id: 'max', name: 'Max', avatar: getImageUrl('./img/Rectangle 1094.png', 'avatar'), online: true },
  ];

  // 模拟聊天列表数据
  const chats: ChatPreview[] = [
    {
      id: 'alex',
      name: 'Alex Linderson',
      avatar: './img/material/Rectangle 14.png',
      lastMessage: 'How are you today?',
      time: '2 min ago',
      unreadCount: 3,
    },
    {
      id: 'team',
      name: 'Team Align',
      avatar: './img/material/Rectangle 14 (1).png',
      lastMessage: "Don't miss to attend the meeting.",
      time: '2 min ago',
      unreadCount: 4,
    },
    {
      id: 'john',
      name: 'John Ahraham',
      avatar: './img/Rectangle 1092 (1).png',
      lastMessage: 'Hey! Can you join the meeting?',
      time: '2 min ago',
    },
    {
      id: 'sabila',
      name: 'Sabila Sayma',
      avatar: './img/material/Rectangle 15.png',
      lastMessage: 'How are you today?',
      time: '2 min ago',
    },
    {
      id: 'borino',
      name: 'John Borino',
      avatar: './img/Rectangle 1094.png',
      lastMessage: 'Have a good day ❤',
      time: '2 min ago',
      online: true,
    },
    {
      id: 'angel',
      name: 'Angel Dayna',
      avatar: './img/material/Rectangle 17.png',
      lastMessage: 'How are you today?',
      time: '2 min ago',
    },
  ];

  const handlePersonaClick = (personaId: string) => {
    navigate(`/chat/${personaId}`);
  };

  const handleChatClick = (chatId: string) => {
    navigate(`/chat/${chatId}`);
  };

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="search-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 21L16.65 16.65" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className="home-title">Home</h1>
        <div className="profile-button">
          <img src={getImageUrl('./img/Rectangle 1092.png', 'user')} alt="Profile" />
        </div>
      </div>

      <div className="personas-scroll">
        {personas.map((persona) => (
          <div 
            key={persona.id} 
            className="persona-item" 
            onClick={() => handlePersonaClick(persona.id)}
          >
            <div className="persona-avatar-container">
              <img 
                src={persona.avatar} 
                alt={persona.name} 
                className="persona-avatar" 
              />
              {persona.online && <div className="online-indicator"></div>}
            </div>
            <div className="persona-name">{persona.name}</div>
          </div>
        ))}
      </div>

      <div className="chats-container">
        {chats.map((chat) => (
          <div 
            key={chat.id} 
            className="chat-preview" 
            onClick={() => handleChatClick(chat.id)}
          >
            <div className="chat-avatar-container">
              <img 
                src={chat.avatar} 
                alt={chat.name} 
                className="chat-avatar" 
              />
              {chat.online && <div className="chat-online-indicator"></div>}
            </div>
            
            <div className="chat-info">
              <div className="chat-header">
                <div className="chat-name">{chat.name}</div>
                <div className="chat-time">{chat.time}</div>
              </div>
              <div className="chat-message">{chat.lastMessage}</div>
            </div>
            
            {chat.unreadCount && (
              <div className="unread-count">{chat.unreadCount}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;